// extracted by mini-css-extract-plugin
module.exports = {"BaseSection":"BaseSection-module__BaseSection___3k6R3","content":"BaseSection-module__content___1bmtE"};